'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var MediaBox = function MediaBox(_ref) {
  var src = _ref.src,
      className = _ref.className,
      caption = _ref.caption,
      props = _objectWithoutProperties(_ref, ['src', 'className', 'caption']);

  return _react2.default.createElement('img', _extends({ className: (0, _classnames2.default)('materialboxed', className), 'data-caption': caption, src: src }, props));
};

MediaBox.propTypes = {
  className: _react.PropTypes.string,
  /**
   * The caption shown below the image when opened
   */
  caption: _react.PropTypes.string,
  /**
   * The path to the image
   */
  src: _react.PropTypes.string.isRequired
};

exports.default = MediaBox;


//////////////////
// WEBPACK FOOTER
// ./~/react-materialize/lib/MediaBox.js
// module id = 242
// module chunks = 0